import React, { useCallback, useMemo } from "react"
import { CalcGenArt } from "@bundles/fast-calculator/data/model"
import { FastCalculatorList } from "@bundles/parts/components/ListV2/FastList/FastCalculatorList"
import {
    FastCalculatorListType,
    ParticularReplaceableItem,
    ParticularStateProvider,
} from "@bundles/parts/components/PureList/ContextProviders/Particular/ParticularContext"
import { Article } from "@tm/models"
import { handleInputSubmit } from "@bundles/fast-calculator/business"
import { useStoreContext } from "@bundles/fast-calculator/state"
import { CalcInput } from "@tm/data/fastCalculator"

type ArticleListV2Props = {
    genarts: CalcGenArt[]
    articles: Article[]
}

export function ArticleListV2({ genarts, articles }: ArticleListV2Props) {
    const instance = useStoreContext()

    const handleArticleChange = useCallback(
        (item: CalcInput, event?: MouseEvent) => {
            event?.stopPropagation()
            handleInputSubmit(instance, item)
        },
        [instance]
    )

    const handleChangeQuantity = useCallback(
        (item: CalcInput, value: number | undefined) => {
            if (value != item.value) {
                handleInputSubmit(instance, { ...item, value: value ?? 0 })
            }
        },
        [instance]
    )

    const handleReplaceButton = useCallback(
        (item: ParticularReplaceableItem) => {
            if ("type" in item) {
                handleInputSubmit(instance, item)
            }
        },
        [instance]
    )

    const context: FastCalculatorListType = useMemo(
        () => ({
            type: "fastCalculatorList",
            genarts,
            articles,
            handleArticleChange,
            handleChangeQuantity,
            handleReplaceButton,
        }),
        [genarts, articles, handleArticleChange, handleChangeQuantity, handleReplaceButton]
    )
    return (
        <ParticularStateProvider value={context}>
            <FastCalculatorList />
        </ParticularStateProvider>
    )
}
